@if (vehicle) {
  @for (vehicle of claim.autoClaimDetails; track vehicle) {
    <div>
      <span>
        {{ (vehicle | vehicle) === '1000 UNK UNK' ? 'Vehicle not on policy' : (vehicle | vehicle) }}
      </span>
    </div>
  }
}
@if (address) {
  <div>
    <span> {{ address | address }} </span>
  </div>
}
